<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/setup/team-mapping" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.CreateTeamMapping") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.CityName") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.CityName')"
                >
                  <v-select
                    label="cityName"
                    v-model="cityName"
                    :options="networkEleData.cityDetailsData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(cityName) => cityName.cityName"
                  >
                    <template v-slot:option="option">{{
                      option.cityName
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Category") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Category')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="categoryId"
                    :options="networkEleData.categoryData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    @input="getcategoryTemplate()"
                    :reduce="(mCodeValue) => mCodeValue.id"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SubCategory") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.SubCategory')"
                >
                  <v-select
                    label="subCategory"
                    v-model="subcategoryId"
                    multiple
                    :options="categoryTemplate"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.id"
                  >
                    <template v-slot:option="option">{{
                      option.subCategory
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Team") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Team')"
                >
                  <v-select
                    label="teamDescription"
                    v-model="teamId"
                    v-if="
                      networkEleData &&
                      networkEleData.ticketTeamData &&
                      networkEleData.ticketTeamData.pageItems
                    "
                    :options="networkEleData.ticketTeamData.pageItems"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.id"
                  >
                    <template v-slot:option="option">{{
                      option.teamDescription
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.TeamHead") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.TeamHead')"
                >
                  <v-select
                    label="username"
                    v-model="userId"
                    disabled
                    :options="networkEleData.appUserData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.id"
                  >
                    <template v-slot:option="option">{{
                      option.username
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ServiceType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ServiceType')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="serviceType"
                    :options="networkEleData.ticketTypeData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(id) => id.mCodeValue"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="createTeam">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      networkEleData: {},
      cityName: "",
      categoryId: "",
      subcategoryId: [],
      serviceType: "",
      teamId: "",
      userId: "",
      systemById: {},
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      categoryTemplate: (state) => state.teamMapping.categoryTemplate,
      createTemplate: (state) => state.teamMapping.createTemplate,
    }),
  },
  methods: {
    async getCreateTemplate() {
      try {
        const response = await this.$store.dispatch(
          "teamMapping/fetchCreateTemplate"
        );
        this.networkEleData = response.data;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getcategoryTemplate() {
      try {
        await this.$store.dispatch(
          "teamMapping/fetchCategoryTemplate",
          this.categoryId
        );
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async createTeam() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let payload = {
        cityName: this.cityName,
        categoryId: this.categoryId,
        subcategoryId: this.subcategoryId,
        serviceType: this.serviceType,
        teamId: this.teamId,
        userId: this.userId,
      };
      try {
        await this.$store.dispatch(
          "teamMapping/createTeamMappingList",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Team Mapping Created Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/team-mapping`);
      } catch (error) {
        let errorMessage = error && error.toString().replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          text: errorMessage,
          type: "error",
        });
      }
    },
    resetForm() {
      this.cityName = "";
      this.categoryId = "";
      this.subcategoryId = [];
      this.serviceType = "";
      this.teamId = "";
      this.userId = "";

      this.$refs.observer.reset();
    },
  },
  watch: {
    teamId(newTeamId) {
      if (
        this.networkEleData &&
        this.networkEleData.ticketTeamData &&
        this.networkEleData.ticketTeamData.pageItems
      ) {
        const selectedTeam = this.networkEleData.ticketTeamData.pageItems.find(
          (team) => team.id === newTeamId
        );
        if (selectedTeam) {
          this.userId = selectedTeam.userId;
        }
      }
    },
  },
  mounted() {
    this.getCreateTemplate();
  },
};
</script>
